import is_server from './is_server'
/**
 * Function to get DPR ( Device Pixel Ratio ) to understand the Quality of images we need to load on certain pages
 */
export default function getDPR() {
	let dpr = 1
	if (!is_server()) {
		// check the pixel ratio
		const pixelDensity = window.devicePixelRatio
		if (pixelDensity !== undefined && pixelDensity > 1) {
			dpr = 2 //retina
		}
	}

	return dpr
}
